import { render, staticRenderFns } from "./ModalViewDetail.vue?vue&type=template&id=553e6668&scoped=true"
import script from "./ModalViewDetail.vue?vue&type=script&lang=js"
export * from "./ModalViewDetail.vue?vue&type=script&lang=js"
import style0 from "./ModalViewDetail.vue?vue&type=style&index=0&id=553e6668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "553e6668",
  null
  
)

export default component.exports